var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataAnalisis({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8800_92280)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0315 4.38016C11.28 4.94962 11.0198 5.61271 10.4504 5.86122C9.12167 6.44104 7.95524 7.33751 7.05305 8.47227C6.15086 9.60703 5.54038 10.9455 5.27499 12.3707C5.00959 13.7959 5.09736 15.2644 5.53062 16.6478C5.96388 18.0313 6.72944 19.2875 7.76036 20.3068C8.79129 21.326 10.0562 22.0771 11.4445 22.4946C12.8328 22.912 14.3022 22.983 15.7243 22.7013C17.1463 22.4197 18.4778 21.794 19.6021 20.8789C20.7265 19.9638 21.6096 18.7872 22.1742 17.452C22.4162 16.8797 23.0763 16.612 23.6486 16.8539C24.2208 17.0959 24.4886 17.756 24.2466 18.3283C23.5388 20.002 22.4318 21.4769 21.0224 22.624C19.613 23.771 17.944 24.5554 16.1614 24.9085C14.3788 25.2615 12.5369 25.1725 10.7966 24.6493C9.05635 24.126 7.47077 23.1844 6.17848 21.9068C4.8862 20.6292 3.92655 19.0545 3.38345 17.3203C2.84036 15.5861 2.73034 13.7453 3.06301 11.9588C3.39569 10.1723 4.16094 8.49447 5.29185 7.07203C6.42276 5.64959 7.8849 4.52584 9.55045 3.79902C10.1199 3.55052 10.783 3.8107 11.0315 4.38016Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2045 3.2045C13.4155 2.99353 13.7016 2.875 14 2.875C15.461 2.875 16.9076 3.16276 18.2574 3.72184C19.6071 4.28092 20.8335 5.10039 21.8666 6.13344C22.8996 7.16649 23.7191 8.3929 24.2782 9.74265C24.8372 11.0924 25.125 12.539 25.125 14C25.125 14.6213 24.6213 15.125 24 15.125H14C13.3787 15.125 12.875 14.6213 12.875 14V4C12.875 3.70163 12.9935 3.41548 13.2045 3.2045ZM15.125 5.19659V12.875H22.8034C22.7039 12.0961 22.5012 11.3322 22.1994 10.6037C21.7534 9.52692 21.0997 8.54855 20.2756 7.72443C19.4515 6.90031 18.4731 6.24658 17.3963 5.80057C16.6678 5.49881 15.9039 5.29613 15.125 5.19659Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8800_92280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataAnalisis);
export default __webpack_public_path__ + "static/media/data-analisis.c371f9dfe08c31677f0cc2763bf22ce7.svg";
export { ForwardRef as ReactComponent };